module.exports = __webpack_public_path__ + "img/betty.6097d13c.png";